import { LoadingSpinner, MetaversePopup, ScreenFrame } from '../components';
import BroadsiderHomeHud from '../components/BroadsiderHud/BroadsiderHomeHud';
import { FirstBattle, BroadsiderFooter, Mint, BroadsiderHomeSelector } from "../components"
import { useState, useEffect, useRef } from 'react';
import { useContentful } from '../hooks';
import useIsMobile from '../hooks/useIsMobile';
import { useInView } from "react-intersection-observer";
import { FigureModel } from '../models';

const HOMESCREEN_MODELS = [ 
  {
    id: '0000',
    name: 'WARHE4D',
    vrm: '/assets/default_avatar.vrm',
    glb: '/assets/default_avatar.vrm',
    image: '/assets/default_avatar.png'
  },
  {
    id: '61685',
    name: 'Shem',
    vrm: '/assets/shem_avatar.vrm',
    glb: '/assets/shem_avatar.vrm',
    image: '/assets/shem_avatar.png'
  },
  {
    id: '2969',
    name: 'Sophia',
    vrm: '/assets/sophia_avatar.vrm',
    glb: '/assets/sophia_avatar.vrm',
    image: '/assets/sophia_avatar.png'
  }
];

export default function Home() {
  const { isLoading, metaverseItems } = useContentful();
  const isMobile = useIsMobile();

  const figures = HOMESCREEN_MODELS.map((f) => FigureModel.fromAlchemyNft(f));
  const [selectedBroadsider, setSelectedBroadsider] = useState(figures[0]);
  const [selectedIndex, setSelectedIndex] = useState(1);

  return (
    <div className='page' style={{ position: 'relative' }}>
      {!isLoading && <div className='menu-placeholder'/>}
      {isLoading && <LoadingSpinner />}
      {!isLoading && !isMobile &&
        <ScreenFrame height='90vh' firstFrame> 
          <BroadsiderHomeHud figures={figures} metaverseData={metaverseItems} selectedBroadsider={selectedBroadsider} selectedIndex={selectedIndex}/>
        </ScreenFrame>
      }
      {!isLoading && isMobile && <ScreenFrame><MetaversePopup content={metaverseItems} standalone={true} forHomePage/></ScreenFrame>}
      {!isLoading && <div style={{"display": "flex", "flexDirection": "column"}}>
          <Mint />
          <BroadsiderFooter/>
        </div>}
      {!isLoading && !isMobile &&
      <div style={{position: 'absolute', top: 0, left: '4rem', height: '200vh'}}>
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'sticky', top: 0 }}>
          <FirstBattle hasControls={false}/>
          <BroadsiderHomeSelector broadsiders={figures} selectedBroadsider={figures[selectedIndex-1]} setSelectedBroadsider={(bs) => setSelectedIndex(figures.findIndex((f) => f.getId() === bs.getId()) + 1)} />
        </div>
      </div>}
    </div>
  );
}
